<template>
  <ul class="tags">
    <li v-if="special && item.articleType && limit === 0" :class="{
          'breaking-news':item.articleType === 'BREAKING_NEWS',
          'editors-choice':item.articleType === 'EDITOR_CHOICE'
        }">
      <router-link :to="`/category/articleType/${item.articleType}`">{{item.articleTypeDisplayName}}</router-link>
    </li>
    <template v-for="(tagItem,idx) in item.topics">
      <li v-if="idx<limit || limit === 0" :key="idx">
        <router-link :to="`/category/topic/${tagItem.name}`">{{tagItem.name}}</router-link>
      </li>
    </template>
    <li class="updated" v-if="item.verification && limit === 0">
      <router-link :to="`/category/verification/true`"
                   v-if="item.verification"
                   class="tag updated">UPDATED</router-link>
    </li>
  </ul>
</template>
<script>
  export default {
    props:{
      item:{
        type:Object,
        default:()=>{return{}},
      },
      special:{
        type:Boolean,
        default:false,
      },
      limit:{
        type:Number,
        default:0,
      },
    },
    data() {
      return {
        starStatus:false,
        loading:false,
      }
    },
    created() {

    },
    methods: {

    },
  }
</script>
